<template>
    <div
        class="
            course-sidebar
            bg-white
            right-0
            z-10
            md:absolute
            flex flex-col
            border-l border-grey-blue
            md:top-16
        "
        style="max-height: calc(100vh - 64px); height: calc(100vh - 64px)"
    >
        <!-- Tab Navigation Header -->
        <div
            class="
                h-16
                flex flex-row
                justify-between
                items-center
                px-3
                border-b border-grey-light
                w-full
                relative
            "
            style="min-height: 64px"
        >
            <custom-button
                @click="SET_SHOW_DOCUMENTS(false)"
                class="w-24 h-9 hover:bg-white-dark rounded-lg transition-all relative"
                :text="'Kursinhalt'"
                :bgColor="'bg-transparent'"
                :textColor="
                    GET_SHOW_DOCUMENTS ? 'text-grey-light' : 'text-grey'
                "
                :id="'course-content'"
            >
                <!-- Aktive Tab Linie für Kursinhalt -->
                <div
                    v-show="!GET_SHOW_DOCUMENTS"
                    class="absolute bottom-0 left-0 right-0 h-0.5 bg-primary rounded-t"
                    style="bottom: -1px;"
                ></div>
            </custom-button>
            <custom-button
                @click="SET_SHOW_DOCUMENTS(true)"
                class="h-9 w-32 hover:bg-magenta-dark rounded-lg transition-all relative"
                :text="'Materialien'"
                :bgColor="
                    GET_SHOW_DOCUMENTS == false
                        ? 'bg-magenta-lightest'
                        : 'bg-magenta'
                "
                :textColor="
                    GET_SHOW_DOCUMENTS == false
                        ? 'text-magenta'
                        : 'text-white'
                "
                :id="'course-materials'"
            >
                <template #icon>
                    <folder-icon
                        :fillClass="
                            GET_SHOW_DOCUMENTS == false
                                ? 'fill-magenta'
                                : 'fill-white'
                        "
                        class="mr-2"
                    />
                </template>
                <!-- Aktive Tab Linie für Materialien -->
                <div
                    v-show="GET_SHOW_DOCUMENTS"
                    class="absolute bottom-0 left-0 right-0 h-0.5 bg-magenta rounded-t"
                    style="bottom: -1px;"
                ></div>
            </custom-button>
        </div>

        <!-- Tab Content -->
        <div
            class="
                course-sidebar-scrollbox
                w-full
                justify-start
                items-center
                scrollbar
            "
        >
            <!-- Kursinhalt Tab -->
            <div v-show="!GET_SHOW_DOCUMENTS" class="w-full">
                <!-- Progress Circles -->
                <div
                    class="
                        w-full
                        flex flex-wrap flex-row
                        justify-evenly
                        items-center
                        mb-2
                        mt-8
                    "
                >
                    <div class="mb-4">
                        <progress-circle
                            :course_finished="GET_COURSE.total_progress.total"
                        />
                        <div class="mt-3 text-sm text-center w-full text-primary">
                            Gesamt
                        </div>
                    </div>
                    <div class="mb-4">
                        <progress-circle
                            :course_finished="GET_COURSE.total_progress.videos"
                        />
                        <div class="mt-3 text-sm text-center w-full text-primary">
                            Videos
                        </div>
                    </div>

                    <div class="mb-4">
                        <progress-circle
                            :course_finished="GET_COURSE.total_progress.tests"
                        />
                        <div class="mt-3 text-sm text-center w-full text-primary">
                            Tests
                        </div>
                    </div>

                    <div class="mb-4">
                        <progress-circle
                            :course_finished="GET_COURSE.total_progress.free_texts"
                        />
                        <div class="mt-3 text-sm text-center w-full text-primary">
                            Übungen
                        </div>
                    </div>
                </div>

                <!-- Course Content List -->
                <list-transition>
                    <sidebar-card
                        :key="'manual'"
                        class="bg-white-dark border-b border-grey-blue"
                        :class="{
                            'hover:bg-primary-lightest cursor-pointer':
                                GET_COURSE.manual.is_read,
                        }"
                        :isFinished="GET_COURSE.manual.is_read"
                        :isLocked="false"
                        text="Anleitung"
                        @select="SET_SELECTED_COURSE_TYPE('manual')"
                    />
                    <sidebar-card
                        :key="'target_agreement'"
                        :class="{
                            'hover:bg-primary-lightest cursor-pointer':
                                GET_COURSE.target_agreement_finished,
                        }"
                        class="bg-white-dark border-b border-grey-blue"
                        :isFinished="GET_COURSE.target_agreement_finished"
                        :isLocked="GET_COURSE.manual.is_read == false"
                        text="Zielvereinbarung"
                        @select="SET_SELECTED_COURSE_TYPE('targetAgreement')"
                    />

                    <section-card
                        v-for="(section, index) in GET_COURSE.sections"
                        :key="section.id"
                        :section="section"
                        :index="index"
                        :activeIndex="state.activeIndex"
                        @select="
                            () => {
                                if (state.activeIndex == index)
                                    state.activeIndex = null;
                                else {
                                    state.activeIndex = index;
                                }
                            }
                        "
                    />
                    <sidebar-card
                        :key="'feedback'"
                        :class="{
                            'hover:bg-primary-lightest cursor-pointer': isDemo
                                ? true
                                : GET_COURSE.total_progress.total == 100,
                        }"
                        class="bg-white-dark border-b border-grey-blue"
                        :isFinished="GET_COURSE.feedback_finished"
                        :isLocked="
                            isDemo ? false : GET_COURSE.total_progress.total < 100
                        "
                        text="Feedback"
                        @select="SET_SELECTED_COURSE_TYPE('feedback')"
                    />

                    <sidebar-card
                        :key="'certificate'"
                        :class="{
                            'hover:bg-primary-lightest cursor-pointer':
                                GET_COURSE.feedback_finished,
                        }"
                        class="bg-white-dark border-b border-grey-blue"
                        :isFinished="GET_COURSE.feedback_finished"
                        :isLocked="GET_COURSE.feedback_finished == false"
                        :text="`Zertifikat (${GET_COURSE.total_progress.total}%)`"
                        @select="SET_SELECTED_COURSE_TYPE('certificate')"
                    />
                </list-transition>
            </div>

            <!-- Materialien Tab -->
            <div v-show="GET_SHOW_DOCUMENTS" class="w-full p-4">
                <!-- Hier wird der Materialien-Inhalt angezeigt -->
                <div class="text-center text-grey-light mt-8">
                    <folder-icon class="mx-auto mb-4 fill-grey-light" style="width: 48px; height: 48px;" />
                    <p class="text-lg font-medium mb-2">Kursmaterialien</p>
                    <p class="text-sm">Hier finden Sie alle verfügbaren Materialien zu diesem Kurs.</p>
                </div>
                
                <!-- Hier können Sie Ihre MaterialsContainer-Komponente einfügen -->
                <!-- <materials-container v-if="GET_SHOW_DOCUMENTS" /> -->
            </div>
        </div>
    </div>
</template>

<script>
import { computed, defineComponent, reactive } from "@vue/runtime-core";
import { useStore } from "vuex";
import ProgressCircle from "../../components/helper/ProgressCircle.vue";
import FolderIcon from "../../components/icons/FolderIcon.vue";
import CustomButton from "../../components/input/CustomButton.vue";
import ListTransition from "../../components/transitions/ListTransition.vue";
import {
    AUTH_USER_TYPES,
    COURSE_TYPES,
    SLIDE_TYPES,
    STORE_TYPES,
} from "../../store/types";
import SectionCard from "./sidebar/SectionCard.vue";
import SidebarCard from "./sidebar/SidebarCard.vue";

export default defineComponent({
    name: "CourseSidebar",
    components: {
        CustomButton,
        FolderIcon,
        ProgressCircle,
        SidebarCard,
        ListTransition,
        SectionCard,
    },
    setup() {
        const store = useStore();
        /**
         *  State
         */
        const state = reactive({ activeIndex: null });
        /**
         *  Functions
         */
        function SET_SELECTED_COURSE_TYPE(type) {
            store.commit(
                `${STORE_TYPES.SLIDES}/${SLIDE_TYPES.SET_SLIDE}`,
                null
            );
            store.commit(
                `${STORE_TYPES.COURSES}/${COURSE_TYPES.SET_SELECTED_COURSE_TYPE}`,
                type
            );
            SET_SHOW_DOCUMENTS(false);
        }
        function SET_SHOW_DOCUMENTS(showDocuments) {
            store.commit(
                `${STORE_TYPES.COURSES}/${COURSE_TYPES.SET_SHOW_DOCUMENTS}`,
                showDocuments
            );
        }
        /**
         *  Computed
         */
        const GET_COURSE = computed(
            () =>
                store.getters[
                    `${STORE_TYPES.COURSES}/${COURSE_TYPES.GET_COURSE}`
                ]
        );
        const GET_SHOW_DOCUMENTS = computed(
            () =>
                store.getters[
                    `${STORE_TYPES.COURSES}/${COURSE_TYPES.GET_SHOW_DOCUMENTS}`
                ]
        );

        const GET_CUSTOMER = computed(() => {
            return store.getters[
                `${STORE_TYPES.AUTH_USER}/${AUTH_USER_TYPES.GET_USER}`
            ];
        });

        const isDemo = computed(() => {
            let isDemo = false;
            if (GET_CUSTOMER.value.authorizations?.length > 0) {
                if (
                    GET_CUSTOMER.value.authorizations[0].name == "Demozugriff"
                ) {
                    isDemo = true;
                }
            }
            return isDemo;
        });

        /**
         *  Created
         */

        return {
            state,
            SET_SHOW_DOCUMENTS,
            SET_SELECTED_COURSE_TYPE,
            GET_COURSE,
            GET_SHOW_DOCUMENTS,
            isDemo,
            GET_CUSTOMER,
        };
    },
});
</script>
<style lang="scss" scoped>
.course-sidebar {
    width: 100%;
    @screen md {
        width: 424px;
        max-width: 40vw;
    }
}
.course-sidebar-scrollbox {
    overflow: unset;
    @screen md {
        overflow: auto;
        height: 100%;
    }
}
</style>
